// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__mUxQs","choiceBoxes":"toolbarselects_choiceBoxes__3weUG","simpleField":"toolbarselects_simpleField__19pGC"};